<template>
  <fragment>
    <g
      id="Eye_Shadow_A-4-1-1"
      v-if="data.value === 'type-1' && data.position === 'b'"
    >
      <g>
        <path
          d="M178.49,176.78c.06-3.55-3.22-14.11,11.07-17.27,12.9-2.85,23.36,2.24,24.8,16.31,.19,1.82-1.82,3.33-4.16,3.17l-31.72-2.21Z"
          :fill="data.color"
        />
        <path
          d="M141.54,176.77c-.06-3.55,2.99-14.1-11.31-17.26-13.05-2.88-23.59,2.36-24.85,16.79-.14,1.57,1.57,2.87,3.58,2.73l32.58-2.27Z"
          :fill="data.color"
        />
      </g>
      <g opacity=".3">
        <path
          d="M178.49,176.78c.06-3.55-3.22-14.11,11.07-17.27,12.9-2.85,23.36,2.24,24.8,16.31,.19,1.82-1.82,3.33-4.16,3.17l-31.72-2.21Z"
          :fill="data.color"
        />
        <path
          d="M141.54,176.77c-.06-3.55,2.99-14.1-11.31-17.26-13.05-2.88-23.59,2.36-24.85,16.79-.14,1.57,1.57,2.87,3.58,2.73l32.58-2.27Z"
          :fill="data.color"
        />
      </g>
    </g>
    <g
      id="Eye_Shadow_A-4-1-1-2"
      v-if="data.value === 'type-1' && data.position === 'm'"
    >
      <g>
        <path
          d="M178.49,171.78c.06-3.55-3.22-14.11,11.07-17.27,12.9-2.85,23.36,2.24,24.8,16.31,.19,1.82-1.82,3.33-4.16,3.17l-31.72-2.21Z"
          :fill="data.color"
        />
        <path
          d="M141.54,171.77c-.06-3.55,2.99-14.1-11.31-17.26-13.05-2.88-23.59,2.36-24.85,16.79-.14,1.57,1.57,2.87,3.58,2.73l32.58-2.27Z"
          :fill="data.color"
        />
      </g>
      <g opacity=".3">
        <path
          d="M178.49,171.78c.06-3.55-3.22-14.11,11.07-17.27,12.9-2.85,23.36,2.24,24.8,16.31,.19,1.82-1.82,3.33-4.16,3.17l-31.72-2.21Z"
          :fill="data.color"
        />
        <path
          d="M141.54,171.77c-.06-3.55,2.99-14.1-11.31-17.26-13.05-2.88-23.59,2.36-24.85,16.79-.14,1.57,1.57,2.87,3.58,2.73l32.58-2.27Z"
          :fill="data.color"
        />
      </g>
    </g>
    <g
      id="Eye_Shadow_A-4-1-1-3"
      v-if="data.value === 'type-1' && data.position === 't'"
    >
      <g>
        <path
          d="M178.49,166.78c.06-3.55-3.22-14.11,11.07-17.27,12.9-2.85,23.36,2.24,24.8,16.31,.19,1.82-1.82,3.33-4.16,3.17l-31.72-2.21Z"
          :fill="data.color"
        />
        <path
          d="M141.54,166.77c-.06-3.55,2.99-14.1-11.31-17.26-13.05-2.88-23.59,2.36-24.85,16.79-.14,1.57,1.57,2.87,3.58,2.73l32.58-2.27Z"
          :fill="data.color"
        />
      </g>
      <g opacity=".3">
        <path
          d="M178.49,166.78c.06-3.55-3.22-14.11,11.07-17.27,12.9-2.85,23.36,2.24,24.8,16.31,.19,1.82-1.82,3.33-4.16,3.17l-31.72-2.21Z"
          :fill="data.color"
        />
        <path
          d="M141.54,166.77c-.06-3.55,2.99-14.1-11.31-17.26-13.05-2.88-23.59,2.36-24.85,16.79-.14,1.57,1.57,2.87,3.58,2.73l32.58-2.27Z"
          :fill="data.color"
        />
      </g>
    </g>
  </fragment>
</template>

<script>
export default {
  name: 'avatarEyeshadowA',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>
